import React, { useState } from 'react';
import CusPageCardContainer from '../../../components/shared/CusPageCardContainer';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FinanceProfileContent from './FinanceProfileContent';

export default function FinanceProfile() {
  const { userId, currency: defaultCurrency } = useParams();
  const { t } = useTranslation();

  const [titleNick, setTitleNick] = useState('');
  const title = `${t('Financial profile')} ${titleNick}`;

  return (
    <CusPageCardContainer title={title} backInfo={'auto'}>
      <Stack gap={1}>
        <FinanceProfileContent
          defaultCurrency={defaultCurrency}
          userId={userId}
          setTitleNick={setTitleNick}
        />
      </Stack>
    </CusPageCardContainer>
  );
}
